import { Builder } from '@builder.io/react';
import {ContactForm} from '../../../features/contact-us-form/contact-us-form'

Builder.registerComponent(ContactForm, {
  name: 'Contact Form',
});
